const SquaresLocalize = {
    'court successfully updated': 'court successfully updated!',
    'court successfully deleted': 'court successfully deleted!'

}

export default SquaresLocalize